module.exports = __webpack_public_path__ + "img/almaty3.3c6f96a0.jpg";